import type { CSSProperties } from 'react';
import type { OrderDrawerFormPicturesBlockProps } from '@/interfaces/views/props/OrderDrawerFormPicturesBlockProps';

export const OrderDrawerFormPicturesBlock: React.FC<OrderDrawerFormPicturesBlockProps> = ({
  pictures,
}) => {
  return (
    <div style={{ display: 'flex' }}>
      {pictures.map((p) => (
        <a key={p.id} id={`${p.id}`} href={p.downloadURL} target="_blank" rel="noreferrer">
          <div
            style={{
              ...styles,
              backgroundImage: `url(${p.downloadURL})`,
            }}
          ></div>
        </a>
      ))}
    </div>
  );
};

const styles: CSSProperties = {
  width: '50px',
  height: '50px',
  backgroundSize: 'cover',
  border: '1px solid',
};
